import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ToastModule } from 'primeng/toast';
import { MainlayoutComponent } from './shared/layout/mainlayout/mainlayout.component';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [
    RouterOutlet,
    MainlayoutComponent,
    ToastModule
  ]
})
export class AppComponent implements OnInit {
  title = 'ALP-CONNEX Management';
  isIframe = false;

  constructor(private msalService: MsalService, private _themeService: ThemeService) {
    registerLocaleData(localeEn);
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
  }
}
